import React from 'react'
import { Link } from 'react-router-dom';
import Header from '../../Components/Header';
import { useProductList } from '../../Hook/App'
import Layout from '../../Layout'
import Tab from '../../Components/Tab';
import Spinner from '../../Components/Spinner';
import Item from '../../Components/Item';
function Index() {
    const { get, category, modal, setModal, products, SaveFilter, loading } = useProductList();

    return (
        <Layout>
            <Header back />
            <div style={{ zIndex: 10 }} className="filters col-lg-4">
                <Link to={"/Filters"}>
                    <div className="sort-btn">
                        <i className="far fa-sort-amount-down-alt"></i>
                    </div>
                </Link>
                <span>
                    <div onClick={() => setModal(true)} className="sort-btn">
                        <i className="far fa-alarm-plus"></i>
                    </div>
                </span>
                <Link to={"/Category"} >
                    <div className="sort" >
                        {category && category.title}
                    </div>
                </Link>
                {category && category.all_option && category.all_option.map((option, i) => {

                    return (<Link key={i} to={"/Filters"}>
                        <div className="sort">
                            {option.name}
                        </div>
                    </Link>
                    )
                })}
            </div>
            <div className="list-main main " style={{ paddingTop: "9rem" }}>
                <div className="result">
                    <div className="row align-items-center">
                        <div className="col-6 lborder">{products && products.total} آگهی</div>
                        <div className="col-6">
                            <select className="btn" onChange={({ target: { value } }) => get({ sort: value })}>
                                <option value="desc">جدید ترین</option>
                                <option value="asc">قدیمی ترین</option>
                            </select>
                        </div>
                    </div>
                </div>
                {loading.products ?
                    <Spinner />
                    :
                    category.id == 1 ?
                        products && products.data && products.data.map((item, i) => {
                            return <Item item={item} key={i} link={"/item/" + item.id} />;
                        })
                        :

                        <Tab items={products && products.data || []} keyList="products" />}
            </div>
            <Modal visable={modal} event={SaveFilter} setVisable={setModal} />
        </Layout>
    )
}
const Modal = ({ visable, event, setVisable }) => {
    return (
        <span
            className='modal'
            style={{ display: visable ? "flex" : "none" }}
            onClick={() => { setVisable(false) }}
        >
            <div className="search-modal">
                <div className="center">
                    <div className="center">
                        <i className="fas fa-bell"></i>
                    </div>
                    <p>آیا این جستجو ذخیره شود؟</p>
                    <p className="light">روزانه آگهی های جدید با این مشخصات به شما اطلاع داده می شود.</p>
                </div>
                <div className="d-flex">
                    <span className="btn blue" onClick={event}>ذخیره جستجو</span>
                    <span className="btn text-danger" onClick={() => { setVisable(false) }} >انصراف</span>
                </div>
            </div>
        </span>
    )
}

export default Index